// eslint-disable-next-line import/no-anonymous-default-export
export default {
  users: [],
  usersLoader: false,
  selectedUser: {},
  usersManaged: {
    list: [],
    loader: false,
  },
  userEntitlements: [],
  entitlementsOfBR: [],
  userManagers: [],
  userOus: [],
};
